// const poster = "https://www.nessma.tv/images/live_nessma.jpg";
// const logoB64 =
//   "data:image/png;base64,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";

const conf = {
  autolaunch: true,
  src:
    "https://cdnamd-hls-globecast.akamaized.net/live/ramdisk/arrabiaa/hls_snrt/index.m3u8",
  playerID: "withUpdate",
  // poster,
  tech: "hlsjs",
  // abrBandWidthFactor: 0.0,
  // abrBandWidthUpFactor: 0.0,
  // maxStarvationDelay: 1000,


  EBLib: {
    broadcasterId: "noorigin",
    manager: "wss://manager.kube.easybroadcast.fr",
    origin: "rd.easybroadcast.fr",
  },
  plugins: {
    videojs_errors: {
      lang: "fr",
    },
    videojs_hotkeys: {
      volumeStep: 0.1,
      seekStep: 60,
      longSeekStep: 1800,
      enableModifiersForNumbers: false,
    },
    // videojs_logo_button: {
    //   origin: "https://www.nessma.tv/",
    //   logo: logoB64,
    // },
    videojs_info_button: {
      default: true,
      title: "Nessma",
      link: "www.nessma.tv",
      href: "https://www.nessma.tv/",
      more: "",
    },

    // videojs_social_sharing: {
    //   title: "Nessma",
    //   links: {
    //     fbLink:
    //       "https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.nessma.tv%2Ffr%2Flive",
    //     twitterLink:
    //       "https://twitter.com/home?status=Nessma%20TV%3A%20live!%0Ahttps%3A//www.nessma.tv/fr/live",
    //   },
    // },
    videojs_quality_selection: true,
  },
  cssLinks: ["//libs.easybroadcast.io/css/video-js6.min.css"],
  css: `
  #selector{
    position:absolute;
    width:100%; 
    height:100%;
  }
  .nessma-player-dimensions{
    width: 100% !important;
    height: 100% !important;
  }
  .video-container{
    padding-top : 0;
  }
  `,
};

module.exports = conf;



// WEBPACK FOOTER //
// ./src/js/generators/mytest.js